import { CustomWindow } from '../../custom.window';

declare const window: CustomWindow;

const useCustomerSupportChat = () => () => {
  if (window.zE) {
    window.zE('messenger', 'open');
  }
};

export default useCustomerSupportChat;
